export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			sheetTypes: [
				{name: "RPK", value: "RPK"},
				{name: "CWK", value: "CWK"},
			],
		}
	},
	computed() {
		// 
	}
};